const eNavbarTitles = {
  dashboard: "Dashboard",
  allPrices: "All Prices",
  negotiations: "Negotiations",
  contracts: "Contracts",
  olfChat: "Chat",
  mySellers: "My Sellers",
  orderHistory: "Order History",
  manageOffers: "Manage Offers",
  orderCapture: "Order Capture",
  pricingEngine: "Pricing Engine",
  manageCustomers: "Manage Customers",
};

export { eNavbarTitles };
